var exports = {
  "I6": "inputWrapper__MWiIxX",
  "rK": "QuotaNotice__WTOuBa",
  "uZ": "composerMinHeight__JcfcFl",
  "Nx": "composerNewConversationMinHeight__c_hx0G",
};

module.exports = exports;
